import ScopeEmissionForm from "./ScopeEmissionForm";

const Scope1Form = () => (
  <ScopeEmissionForm scopeKey="scope1" label="Scope 1 Emissions" />
);

export default Scope1Form;
